import { render, staticRenderFns } from "./Midia.vue?vue&type=template&id=b5689846&scoped=true"
import script from "./Midia.vue?vue&type=script&lang=js"
export * from "./Midia.vue?vue&type=script&lang=js"
import style0 from "./Midia.vue?vue&type=style&index=0&id=b5689846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5689846",
  null
  
)

export default component.exports